import {Client} from "./client.model";
import {User} from "./user.model";
import {Pet} from "./pet.model";
import {WellnessPlan} from "./wellness-plan.model";
import {VetClinic} from "./vet-clinic.model";
import {UserCarePlanItem} from "./user-care-plan-item.model";
import {UserCarePlanVetineoVisitTypeBundle} from "./user-care-plan-vetineo-visit-type-bundle.model";

/**
 * Reprezentuje aktywny abonament wykupiony dla konkretnego pacjenta.
 * Jest to główny kontener łączący definicję produktu (`WellnessPlan`) z właścicielem i zwierzęciem.
 * Przechowuje listę dostępnych usług, które są "konsumowane" w trakcie trwania umowy.
 */
export class UserCarePlan {
  /** Unikalny identyfikator abonamentu użytkownika. */
  public uuid: string;
  public authorUUID: string;
  public editorUUID: string;
  public created: Date;
  public modified: Date;
  public deleted: Date;
  /** ID klienta B2B, w ramach którego plan został zakupiony. */
  public vClientId: number;
  public vClient: Client;
  /** Obiekt właściciela planu. */
  public user: User;
  public userUUID: string;
  /** Obiekt pacjenta (zwierzęcia), do którego przypisane są usługi. */
  public pet: Pet;
  public petUUID: string;
  public mobilePhone: string;
  public email: string;
  public carePlanOwnerCompany: string;
  public firstName: string;
  public lastName: string;
  /** Wartość zniżki udzielonej na ten konkretny plan. */
  public discount: number;
  /** Definicja szablonu, na podstawie którego utworzono ten plan. */
  public wellnessPlan: WellnessPlan;
  public wellnessPlanUUID: string;
  /** Data aktywacji planu (rozpoczęcia świadczenia usług). */
  public activation: Date;
  /** Lista klinik, w których ten plan jest honorowany. */
  public vetClinics: VetClinic[];
  /**
   * Lista konkretnych usług/towarów dostępnych w ramach planu.
   * Np. "Szczepienie przeciw wściekliźnie", "Odrobaczenie".
   */
  public userCarePlanItems: UserCarePlanItem[];
  /**
   * Lista typów wizyt (usług lekarskich) dostępnych w ramach planu.
   */
  public userCarePlanVetineoVisitTypeBundles: UserCarePlanVetineoVisitTypeBundle[];

}
